import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["inner", "caretIcon"]

  connect() { }

  toggle(e) {
    e.preventDefault()
    this.innerTarget.classList.toggle("hidden")
    this.caretIconTarget.classList.toggle("rotate-180")
  }

}